import React from "react";
import { Result } from "antd";

const Unauthorized = () => {
  return (
    <React.Fragment>
      <Result
        status="error"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
      />
    </React.Fragment>
  );
};

export default Unauthorized;
